import {SideBar} from 'components/src/sidebar/SideBar'
import {useTranslation} from "react-i18next";

/**
 * AppSidebar component provides the main navigation sidebar of the application.
 */
export const EnterprisePortalSidebar = () =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation('portal');

    return (
        <SideBar>
            <SideBar.Item title={t('menu.home-title')} link="/"/>
            <SideBar.Item title={t('menu.pdf-password-title')} link="/pdf/otp"/>
            <SideBar.Item title={t('menu.messages-title')} link="/messages"/>
        </SideBar>
    )
}
